const tamil = {
    name: "Tamil",
    native_name: "தமிழ்",
    code: "tm",
  };
  
  const tm = {
    translation: {
        report_bug: "பிழையைப் புகாரளிக்கவும்",
        import: "இறக்குமதி",
        file: "கோப்பு",
        new: "புதியது",
        new_window: "புதிய சாளரம்",
        open: "திற",
        save: "சேமிக்க",
        save_as: "மற்றொரு பெயரில் சேமிக்க",
        save_as_template: "வார்ப்புருவாக சேமிக்க",
        template_saved: "வார்ப்புரை சேமிக்கப்பட்டது!",
        rename: "பெயர் மாற்ற",
        delete_diagram: "வரைவைப் அழிக்க",
        are_you_sure_delete_diagram: "இந்த வரைவைக் கணியலை நீக்க விரும்புகிறீர்களா? இந்த செயல்பாடு மாற்றமுடியாதது.",
        oops_smth_went_wrong: "ஓப்பஸ்! ஏதோ தவறானது.",
        import_diagram: "வரைவைக் கணியம் செய்ய",
        import_from_source: "SQL-இலிருந்து இறக்குமதி செய்ய",
        export_as: "வெளியீடு செய்ய",
        export_source: "SQL ஆக வெளியீடு",
        models: "மாதிரிகள்",
        exit: "வெளியேறு",
        edit: "தொகு",
        undo: "திரும்பெடு",
        redo: "மீண்டும் செய்",
        clear: "அழிக்க",
        are_you_sure_clear: "இந்த வரைவைக் கணியலை அகற்ற விரும்புகிறீர்களா? இது மாற்றமுடியாதது.",
        cut: "வெட்டு",
        copy: "நகலெடு",
        paste: "ஒட்டு",
        duplicate: "மறுபடி செய்ய",
        delete: "அழி",
        copy_as_image: "படமாக நகலெடு",
        view: "காண",
        header: "மெனுபட்டி",
        sidebar: "பக்கப்பட்டி",
        issues: "சிக்கல்கள்",
        presentation_mode: "வழங்கல் முறை",
        strict_mode: "கடுமையான முறை",
        field_details: "புலம் விவரங்கள்",
        reset_view: "காட்சியை மீட்டமை",
        show_grid: "கட்டத்தை காட்ட",
        show_cardinality: "பெருந்தன்மையை காட்ட",
        theme: "தீம்",
        light: "ஒளி",
        dark: "இருள்",
        zoom_in: "பெரிதாக்கு",
        zoom_out: "சிறிதாக்கு",
        fullscreen: "முழுத்திரை",
        settings: "அமைப்புகள்",
        show_timeline: "நேரவரிசையை காட்ட",
        autosave: "தானியங்கு சேமிப்பு",
        panning: "திரைவிரிப்பு",
        show_debug_coordinates: "பிழைத்திருத்த இடங்களை காட்ட",
        transform: "மாற்று",
        viewbox: "காட்சி பெட்டி",
        cursor_coordinates: "நாட்டெண்",
        coordinate_space: "இடம்",
        coordinate_space_screen: "திரை",
        coordinate_space_diagram: "வரைவுக் கணியம்",
        table_width: "அட்டவணை அகலம்",
        language: "மொழி",
        flush_storage: "சேமிப்பை கழிக்க",
        are_you_sure_flush_storage: "சேமிப்பை அழிக்க விரும்புகிறீர்களா? இது உங்கள் அனைத்து வரைவுகளையும் தனிப்பயனாக்கிய வார்ப்புருக்களை நீக்கும்.",
        storage_flushed: "சேமிப்பு கழிக்கப்பட்டது",
        help: "உதவி",
        shortcuts: "குறுக்குவழிகள்",
        ask_on_discord: "Discord-ல் கேளுங்கள்",
        feedback: "கருத்து",
        no_changes: "மாற்றங்கள் இல்லை",
        loading: "ஏற்றுகிறது...",
        last_saved: "கடைசியாக சேமிக்கப்பட்டது",
        saving: "சேமிக்கிறது...",
        failed_to_save: "சேமிக்க முடியவில்லை",
        fit_window_reset: "சாளரத்திற்கு பொருத்து / மீட்டமை",
        zoom: "பெரிதாக்கு",
        add_table: "அட்டவணையைச் சேர்",
        add_area: "பகுதியைச் சேர்",
        add_note: "குறிப்பைச் சேர்",
        add_type: "வகையைச் சேர்",
        to_do: "செய்யவேண்டியது",
        tables: "அட்டவணைகள்",
        relationships: "தொடர்புகள்",
        subject_areas: "பொருள் பகுதிகள்",
        notes: "குறிப்புகள்",
        types: "வகைகள்",
        search: "தேடு...",
        no_tables: "அட்டவணைகள் இல்லை",
        no_tables_text: "உங்கள் வரைவைக் கணியம் தொடங்குங்கள்!",
        no_relationships: "தொடர்புகள் இல்லை",
        no_relationships_text: "புலங்களை இணைக்க இழுத்து விடுங்கள் மற்றும் தொடர்புகளை உருவாக்குங்கள்!",
        no_subject_areas: "பொருள் பகுதிகள் இல்லை",
        no_subject_areas_text: "அட்டவணைகளை குழுவாகச் சேர்க்க பொருள் பகுதிகளைச் சேர்க்கவும்!",
        no_notes: "குறிப்புகள் இல்லை",
        no_notes_text: "கூடுதல் தகவலைப் பதிவு செய்ய குறிப்புகளைப் பயன்படுத்துங்கள்",
        no_types: "வகைகள் இல்லை",
        no_types_text: "உங்கள் சொந்த தனிப்பயன் தரவுப் வகைகளை உருவாக்குங்கள்",
        no_issues: "சிக்கல்கள் கண்டுபிடிக்கவில்லை.",
        strict_mode_is_on_no_issues: "கடுமையான முறை அணைக்கப்பட்டுள்ளது எனவே சிக்கல்கள் காண்பிக்கப்படாது.",
        name: "பெயர்",
        type: "வகை",
        null: "சுழி",
        not_null: "சுழியல்ல",
        primary: "முதன்மை",
        unique: "தனித்துவம்",
        autoincrement: "தானியங்கி அதிகரிப்பு",
        default_value: "இயல்புநிலை",
        check: "சரிபார்",
        this_will_appear_as_is: "*இது உருவாக்கப்பட்ட ஸ்கிரிப்டில் உள்ளபடியே தோன்றும்.",
        comment: "கருத்து",
        add_field: "புலம் சேர்க்க",
        values: "மதிப்புகள்",
        size: "அளவு",
        precision: "துல்லியம்",
        set_precision: "துல்லியத்தை அமைக்க: 'அளவு, எண்கள்'",
        use_for_batch_input: "தொகுதி உள்ளீடிற்கு , பயன்படுத்தவும்",
        indices: "சுட்டிகள்",
        add_index: "சுட்டி சேர்க்க",
        select_fields: "புலங்களைத் தேர்ந்தெடு",
        title: "தலைப்பு",
        not_set: "அமைக்கப்படவில்லை",
        foreign: "வெளிநாட்டு",
        cardinality: "பெருந்தன்மை",
        on_update: "புதுப்பிக்கும்போது",
        on_delete: "அழிக்கும்போது",
        swap: "மாற்றம்",
        one_to_one: "ஒன்றுக்கு ஒன்று",
        one_to_many: "ஒன்றுக்கு பல",
        many_to_one: "பலக்கு ஒன்று",
        content: "உள்ளடக்கம்",
        types_info: "இந்த அம்சம் PostgreSQL போன்ற பொருள் தொடர்புடைய DBMS-களுக்காகவே. MySQL அல்லது MariaDB க்கு பயன்படுத்தப்படும் போது JSON வகை உருவாக்கப்படும் அதற்கான json சரிபார்ப்பு ஆய்வுடன். SQLite க்கு பயன்படுத்தப்படும் போது இது BLOB ஆக மாற்றப்படும். MSSQL க்கு பயன்படுத்தப்படும் போது முதற்கொண்டு கணியலுக்கு ஒரே வகை மாற்றம் உருவாக்கப்படும்.",
        table_deleted: "அட்டவணை அழிக்கப்பட்டது",
        area_deleted: "பகுதி அழிக்கப்பட்டது",
        note_deleted: "குறிப்பு அழிக்கப்பட்டது",
        relationship_deleted: "தொடர்பு அழிக்கப்பட்டது",
        type_deleted: "வகை அழிக்கப்பட்டது",
        cannot_connect: "இணைக்க முடியாது, புலங்கள் மாறுபட்ட வகைகளில் உள்ளன",
        copied_to_clipboard: "கிளிப்போர்டில் நகலெடுக்கப்பட்டது",
        create_new_diagram: "புதிய வரைவைக் கணியம் உருவாக்க",
        cancel: "ரத்து செய்",
        open_diagram: "வரைவைக் கணியம் திற",
        rename_diagram: "வரைவுக் கணியலின் பெயரை மாற்று",
        export: "வெளியீடு செய்",
        export_image: "படமாக வெளியீடு செய்",
        create: "உருவாக்கு",
        confirm: "உறுதிப்படுத்து",
        last_modified: "கடைசியாக மாற்றப்பட்டது",
        drag_and_drop_files: "கோப்புகளை இங்கு இழுத்து விடவும் அல்லது கிளிக்கி பதிவேற்றவும்.",
        support_json_and_ddb: "JSON மற்றும் DDB கோப்புகள் ஆதரிக்கப்படுகின்றன",
        upload_sql_to_generate_diagrams: "sql கோப்பை பதிவேற்றம் செய்து உங்கள் அட்டவணைகளையும் புலங்களையும் தானாக உருவாக்குங்கள்.",
        overwrite_existing_diagram: "ஏற்கனவே உள்ள வரைவைக் கணியலை மீட்டமைக்க",
        only_mysql_supported: "*தற்காலிகமாக மட்டும் MySQL ஸ்கிரிப்ட்கள் மட்டுமே ஆதரிக்கப்படும்.",
        blank: "வெற்று",
        filename: "கோப்புப்பெயர்",
        table_w_no_name: "பெயர் இல்லாத அட்டவணை அறிவிக்கப்பட்டது",
        duplicate_table_by_name: "'{{tableName}}' என்ற பெயரில் நகல் அட்டவணை",
        empty_field_name: "'{{tableName}}' அட்டவணையில் `name` புலம் வெறுமையாக உள்ளது",
        empty_field_type: "'{{tableName}}' அட்டவணையில் `type` புலம் வெறுமையாக உள்ளது",
        no_values_for_field: "'{{tableName}}' அட்டவணையில் '{{fieldName}}' புலம் `{{type}}` வகையில் உள்ளது ஆனால் மதிப்புகள் குறிப்பிடப்படவில்லை",
        default_doesnt_match_type: "'{{tableName}}' அட்டவணையில் '{{fieldName}}' புலத்திற்கு இயல்புநிலை மதிப்பு அதன் வகையுடன் பொருந்தவில்லை",
        not_null_is_null: "'{{tableName}}' அட்டவணையில் '{{fieldName}}' புலம் சுழியல்ல ஆனால் இயல்புநிலை சுழி உள்ளது",
        duplicate_fields: "'{{tableName}}' அட்டவணையில் '{{fieldName}}' என்ற பெயரில் நகல் புலங்கள்",
        duplicate_index: "'{{tableName}}' அட்டவணையில் '{{indexName}}' என்ற பெயரில் நகல் சுட்டி",
        empty_index: "'{{tableName}}' அட்டவணையில் சுட்டி எந்த புலங்களையும் குறிப்பிடவில்லை",
        no_primary_key: "'{{tableName}}' அட்டவணையில் முதன்மை விசை இல்லை",
        type_with_no_name: "பெயர் இல்லாத வகை அறிவிக்கப்பட்டது",
        duplicate_types: "'{{typeName}}' என்ற பெயரில் நகல் வகைகள்",
        type_w_no_fields: "'{{typeName}}' என்ற பெயரில் வெறுமையான வகை அறிவிக்கப்பட்டது",
        empty_type_field_name: "'{{typeName}}' வகையில் `name` புலம் வெறுமையாக உள்ளது",
        empty_type_field_type: "'{{typeName}}' வகையில் `type` புலம் வெறுமையாக உள்ளது",
        no_values_for_type_field: "'{{typeName}}' வகையில் '{{fieldName}}' புலம் `{{type}}` வகையில் உள்ளது ஆனால் மதிப்புகள் குறிப்பிடப்படவில்லை",
        duplicate_type_fields: "'{{typeName}}' வகையில் '{{fieldName}}' என்ற பெயரில் நகல் புலங்கள்",
        duplicate_reference: "'{{refName}}' என்ற பெயரில் நகல் குறிப்பு",
        circular_dependency: "'{{refName}}' அட்டவணை குறித்த சுழற்சி சார்பு",
        timeline: "நேரவரிசை",
        priority: "முக்கியத்துவம்",
        none: "இல்லை",
        low: "குறைவு",
        medium: "நடுத்தர",
        high: "அதிகம்",
        sort_by: "வரிசைப்படுத்து",
        my_order: "என் ஒழுங்கு",
        completed: "முடிந்தது",
        alphabetically: "அகரவரிசையில்",
        add_task: "பணி சேர்க்க",
        details: "விவரங்கள்",
        no_tasks: "உங்களுக்கு பணிகள் இல்லை.",
        no_activity: "உங்களுக்கு செயல்பாடுகள் இல்லை.",
        move_element: "{{name}} ஐ {{coords}}க்கு மாற்று",
        edit_area: "{{extra}} பகுதியைத் திருத்து {{areaName}}",
        delete_area: "பகுதியை நீக்கு {{areaName}}",
        edit_note: "{{extra}} குறிப்பைத் திருத்து {{noteTitle}}",
        delete_note: "குறிப்பை நீக்கு {{noteTitle}}",
        edit_table: "{{extra}} அட்டவணையைத் திருத்து {{tableName}}",
        delete_table: "அட்டவணையை நீக்கு {{tableName}}",
        edit_type: "{{extra}} வகையைத் திருத்து {{typeName}}",
        delete_type: "வகையை நீக்கு {{typeName}}",
        add_relationship: "தொடர்பைச் சேர்க்க",
        edit_relationship: "{{extra}} தொடர்பைத் திருத்து {{refName}}",
        delete_relationship: "தொடர்பை நீக்கு {{refName}}",
        not_found: "கண்டுபிடிக்கவில்லை",
        pick_db: "தரவுத்தொகுப்பைத் தேர்ந்தெடு",
        generic: "பொது",
        generic_description: "பொது வரைவை எந்த SQL வகைக்கும் ஏற்றexport செய்யலாம், ஆனால் சில தரவுவகைகளை மட்டுமே ஆதரிக்கும்.",
        enums: "எனம்கள்",
        add_enum: "எனத்தைச் சேர்க்க",
        edit_enum: "{{extra}} எனத்தைத் திருத்து {{enumName}}",
        delete_enum: "எனத்தை நீக்கு",
        enum_w_no_name: "பெயர் இல்லாத எனம் கண்டுபிடிக்கப்பட்டது",
        enum_w_no_values: "'{{enumName}}' எனத்தில் மதிப்புகள் இல்லை",
        duplicate_enums: "'{{enumName}}' என்ற பெயரில் நகல் எனங்கள்",
        no_enums: "எனங்கள் இல்லை",
        no_enums_text: "இங்கே எனங்களை வரையறுக்கவும்",
        declare_array: "வரிசையாக அறிவி",
        empty_index_name: "'{{tableName}}' அட்டவணையில் பெயர் இல்லாத சுட்டி அறிவிக்கப்பட்டது",
        didnt_find_diagram: "ஓப்பஸ்! வரைவை கண்டுபிடிக்க முடியவில்லை.",
    },
};

  
  export { tm, tamil };
  